var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	15060: {
		fallback: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^18.3.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	9555: {
		fallback: () => (__webpack_require__.e(143).then(() => (() => (__webpack_require__(8143))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">=16.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	12755: {
		fallback: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">=16.6.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	21876: {
		fallback: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^17.0.0 || ^18.0.0 || ^19.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	29341: {
		fallback: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">= 16.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	42321: {
		fallback: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "18.3.1",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	43107: {
		fallback: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">= 16.8.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	43547: {
		fallback: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">=16.8",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	51310: {
		fallback: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^18 || ^19",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	60517: {
		fallback: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">=16.8.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	65114: {
		fallback: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">=16.9.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	72869: {
		fallback: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	86209: {
		fallback: () => (__webpack_require__.e(143).then(() => (() => (__webpack_require__(8143))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: false,
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	45200: {
		fallback: () => (__webpack_require__.e(143).then(() => (() => (__webpack_require__(8143))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">=16.9.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	42518: {
		fallback: () => (__webpack_require__.e(143).then(() => (() => (__webpack_require__(8143))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^17.0.0 || ^18.0.0 || ^19.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	98899: {
		fallback: () => (__webpack_require__.e(143).then(() => (() => (__webpack_require__(8143))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: ">=16.6.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	32078: {
		fallback: () => (__webpack_require__.e(758).then(() => (() => (__webpack_require__(30758))))),
		shareScope: ["default"],
		singleton: false,
		requiredVersion: "^18.0.0 || ^19.0.0",
		strictVersion: true,
		eager: false,
		layer: undefined,
		shareKey: "react",

	}
};
var moduleToHandlerMapping = {};
// no consumes in initial chunks
__webpack_require__.consumesLoadingData.chunkMapping = {
	"60": [
		15060
	],
	"68": [
		42518,
		98899
	],
	"78": [
		32078
	],
	"200": [
		45200
	],
	"697": [
		9555,
		12755,
		21876,
		29341,
		42321,
		43107,
		43547,
		51310,
		60517,
		65114,
		72869,
		86209
	]
};
__webpack_require__.f.consumes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}